import React, { forwardRef, useImperativeHandle } from 'react'
import { Box } from '@material-ui/core'

import { BaseStatusCard } from 'components'

import useFetch from 'hooks/useFetch'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import useStyles from './styles'

const ProgressStatsCards = forwardRef(
  ({ filter, preAvaliation = false }, ref) => {
    const classes = useStyles()

    const { PROGRESS_STATS_CARD_ITEMS } = constants.companySuppliers
    const { STEPS } = constants.tours.thirdPartyManagements
    const { handleStatusCard } = helpers.baseStatusCard

    const { response, isLoading, refresh } = useFetch(
      service.dponet.suppliers.progressStats,
      { preAvaliation },
      [],
    )

    useImperativeHandle(ref, () => ({
      refresh,
    }))

    const stats = response?.data || {}

    const progressStatsCardItems = PROGRESS_STATS_CARD_ITEMS.map((item) => ({
      ...item,
      title: stats?.[item.statsKey ?? item.status] ?? 0,
    }))

    return (
      <Box
        id={
          preAvaliation
            ? STEPS.PRE_AVALIATION.DEFAULT[3]
            : STEPS.MY_SUPPLIERS[3]
        }
        className={classes.gridContainer}
      >
        {progressStatsCardItems.map((item) => (
          <BaseStatusCard
            key={item.status}
            title={item.title}
            {...item}
            selected={filter.filters?.progressStatus === item.status}
            onClick={() =>
              handleStatusCard({
                filter,
                value: item.status,
                key: 'progressStatus',
              })
            }
            variant="square"
            titleProps={{ variant: 'h2' }}
            titleResponse
            isLoading={isLoading}
          />
        ))}
      </Box>
    )
  },
)

// Para, ao debugar, aparecer o nome correto do componente (<ProgressStatsCards />) e não apenas <ForwardRef />
ProgressStatsCards.displayName = 'ProgressStatsCards'

export default ProgressStatsCards
